import axios from 'axios'
import {API_URL} from '../../../../_metronic/helpers'
import type {AuthModel} from './_models'
import type {CompletionMoment} from './accountCompletion'
import {isStaff} from './staffAccess'

// «انتخاب دستگاه» (user decision 2026-10-29): an account stays signed in on at most two devices of each kind at a time —
// browsers, «معتمد آسا» for Android, the panel installed as an app. A sign-in past that opens nothing but this page
// (the server answers every other request 403 DEVICE_LIMIT) until the user signs one of the others out. Nothing is
// ever closed without the user's choice.

export {DEVICE_LIMIT} from './accountGateCodes'

export type DeviceKind = 'browser' | 'app' | 'pwa'

/** TokenReturn.deviceLimit: this sign-in is past the limit of its kind. */
export type DeviceLimitFlag = {kind: DeviceKind; kindLabel: string; limit: number}

export type DeviceLimitSession = {
  id: string
  device: {label: string; icon?: string | null}
  location?: string | null
  signedInAt?: CompletionMoment | null
  lastActiveAt?: CompletionMoment | null
}

export type DeviceLimitState = DeviceLimitFlag & {
  sessions: DeviceLimitSession[]
  /** The other sign-ins ended meanwhile and the server cleared the wait: sign-out with no ids gives the session. */
  resolved?: boolean
}

// Built when called, never while the module loads (the helpers may not be initialised yet).
const devicesUrl = () => `${API_URL}/account/devices/limit`

/** A support or staff session is no customer account: it never sees the page (the server sends no flag for it). */
export const isOverDeviceLimit = (
  user?: Pick<AuthModel, 'deviceLimit' | 'support' | 'staff'> | null
) => Boolean(user?.deviceLimit) && !user?.support && !isStaff(user)

export const getDeviceLimit = () =>
  axios.get<DeviceLimitState>(devicesUrl()).then((response) => response.data)

export const signOutLimitedDevices = (ids: string[]) =>
  axios.post<{user: AuthModel}>(`${devicesUrl()}/sign-out`, {ids}).then((response) => response.data)

const DEVICE_ICONS: Record<DeviceKind, string> = {
  browser: 'la-laptop',
  app: 'la-mobile-alt',
  pwa: 'la-window-maximize',
}

export const deviceIconOf = (kind: DeviceKind, icon?: string | null) =>
  icon && /^la-[a-z-]+$/.test(icon) ? icon : DEVICE_ICONS[kind] || 'la-laptop'
